import { configureStore } from "@reduxjs/toolkit";
import searchReducer from "./reducers/search_reducer";

const store = configureStore({
  reducer: searchReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export default store;
